import type { ComponentPropsWithoutRef } from 'react';
import { AlertIcon } from '../icons';
import { cn } from '@/lib/utils';

export function InlineNotice({ className, children, ...props }: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...props}
      className={cn(
        'inline-flex items-center gap-1 rounded-xs bg-chilli-blush p-2',
        'font-inter text-xs font-normal leading-tight text-chilli-red',
        className,
      )}
    >
      {/* 12px outlined ring, per the frame. The solid AlertCircleIcon is the
          pickup-alerts panel's glyph, not this one. */}
      <AlertIcon aria-hidden="true" className="size-4 shrink-0" />
      <p className="min-w-0">{children}</p>
    </div>
  );
}
